import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import { PreConfigButton1 } from '../../nav-list/recursive-sidebar/configuration/preconfig';
import { CNCRoutes } from './cnc-routes';
import { CompoundingRoutes } from './compounding-routes';
import { CompressionRoutes } from './compression-routes';
import { HPsRoutes } from './hps-routes';
import { InjectionMoldingRoutes } from './Injection-molding-routes';
import { IntakesRoutes } from './intakes-routes';
import { LaboratorioRoutes } from './laboratorio-routes';
import { PlasticRoutes } from './plastic-routes';
import { PolyurethaneRoutes } from './polyurethane-routes';
import { TanksRoutes } from './tanks-routes';
import { PleatPackRoutes } from './pleat-pack-routes';
import { nave4NavRoutes } from './nave4-routes';
import { CortesRoutes } from './cortes-routes';
import { FILTERS_SIDENAV_OPTIONS } from '@dep/filters/utils';
import { HOSES_SIDENAV_OPTIONS } from '@dep-hoses/utils/sidenav-options';
import { LIDS_SIDENAV_OPTIONS } from '@dep-lids/utils/sidenav-options';

export const DepartamentosNavRoutes: SideBarButton = {
  data: {
    name: 'Departamentos',
  },
  options: PreConfigButton1,
  icon: 'list',
  butons: [
    IntakesRoutes,
    TanksRoutes,
    HPsRoutes,
    PlasticRoutes,
    CortesRoutes,
    LIDS_SIDENAV_OPTIONS,
    PolyurethaneRoutes,
    InjectionMoldingRoutes,
    CompressionRoutes,
    CompoundingRoutes,
    LaboratorioRoutes,
    HOSES_SIDENAV_OPTIONS,
    CNCRoutes,
    PleatPackRoutes,
    FILTERS_SIDENAV_OPTIONS,
    // FilterFontanaRoutes,
    nave4NavRoutes,
  ],
};
